import * as React from 'react';
import { ConfigOptions, ConfigOptionsAPI } from '../../../api';
import { Button, Checkbox, Form, Input, Label, Segment } from 'semantic-ui-react';
import * as ReactTooltip from 'react-tooltip';

class State {
}

interface Props {
}

interface ProbeConfig {
    sysName: string;
    sysDesc: string;
    sysPublicIpAddr: string;
    sysContact: string;
    sysAddrStreet: string;
    sysAddrCity: string;
    sysAddrState: string;
    sysAddrPostalCode: string;
    sysAddrCountry: string;
    sysLocLat: string;
    sysLocLong: string;
    sysMemo: string;
    sysIvmsUseExtIp: boolean;
}

export default class ProbeConfigPanel extends React.Component<Props, State> {

    tooltipRenderer() {
        return <ReactTooltip effect="float" place="top" html={true} delayShow={250} offset={{top: 10, left: 10}} className="tool-tip-override-general"/>;
    }

    render() {
        /* Config Options API

            Use the ConfigOptionsAPI<> component to take care of all the gritty API data fetch and updates. We pass in
            our Options as a <generic parameter type>. Although it can work without the ProbeConfig type (using any),
            by specifying it our intellisense will work and type checking is performed.

            The ConfigOptionsAPI component renders a html FORM,

            Properties:
               module - specify the Options API module name that the options are contained (one of sysmgmt, abr, fm, port)
               defaults - specify default for options (if we dont, we will get a React controlled/uncontrolled warning in console)
               spinner - enable a spinner during initial loading of configuration (default is true but you probably wont see it fast enough)
        */
        return (
              <ConfigOptionsAPI<ProbeConfig>
                  module="sysmgmt"
                  defaults={{
                      sysName: '',
                      sysDesc: '',
                      sysPublicIpAddr: '',
                      sysContact: '',
                      sysAddrStreet: '',
                      sysAddrCity: '',
                      sysAddrState: '',
                      sysAddrPostalCode: '',
                      sysAddrCountry: '',
                      sysLocLat: '',
                      sysLocLong: '',
                      sysMemo: '',
                      sysIvmsUseExtIp: false
                  }}
              >
                  { (config: ConfigOptions<ProbeConfig>) => {
                      // want to see what options come back? enable this console.log
                      // console.log("config ", config);

                      /* here we render our config form. You should add at least one Apply button and tie a number of
                         HTML input components to the 'config' object. The config object supports these properties:

                         Get an option:
                         config.options.<option-name>

                         Update an option:
                         config.update.<option-name>(new_value)

                         Wire input onChange event to update an option:
                         <Input ... onChange={config.onChange.<option-name>}

                       */
                      return (
                          <React.Fragment>
                               <div className="assetAliasFilters">
                                    <Label className="system-config-pageHeader">
                                        Probe
                                    </Label>
                                   <Button
                                       floated="right"
                                       className="rightButton"
                                       content="Apply"
                                       title="Update Config"
                                   />
                               </div>
                                <Segment.Group className="system-config-segment">
                                    <Segment>
                                        <Form>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    System Name
                                                </Label>
                                                <Input
                                                    className="input-width-450"
                                                    value={config.options.sysName}
                                                    onChange={config.onChange.sysName}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    System Description
                                                </Label>
                                                <Input
                                                    className="input-width-450"
                                                    value={config.options.sysDesc}
                                                    onChange={config.onChange.sysDesc}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    External IP Address
                                                </Label>
                                                {this.tooltipRenderer()}
                                                <Input
                                                    data-tip={config.options.sysPublicIpAddr}
                                                    className="input-width-450"
                                                    value={config.options.sysPublicIpAddr}
                                                    onChange={config.onChange.sysPublicIpAddr}
                                                />
                                                {' '}
                                                <Checkbox
                                                    className="config-checkbox"
                                                    checked={config.options.sysIvmsUseExtIp}
                                                    onChange={config.onChange.sysIvmsUseExtIp}
                                                />
                                                <Label className="left-align-label" data-tip="Tell management system to always use External IP Address instead of internal IP address">
                                                    Use External IP Address
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    System Contact
                                                </Label>
                                                <Input
                                                    className="input-width-450"
                                                    value={config.options.sysContact}
                                                    onChange={config.onChange.sysContact}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    Street Address
                                                </Label>
                                                <Input
                                                    className="input-width-450"
                                                    value={config.options.sysAddrStreet}
                                                    onChange={config.onChange.sysAddrStreet}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    City
                                                </Label>
                                                <Input
                                                    className="input-width-450"
                                                    value={config.options.sysAddrCity}
                                                    onChange={config.onChange.sysAddrCity}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    State
                                                </Label>
                                                <Input
                                                    className="input-width-450"
                                                    value={config.options.sysAddrState}
                                                    onChange={config.onChange.sysAddrState}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    Postal Code
                                                </Label>
                                                <Input
                                                    className="input-width-450"
                                                    value={config.options.sysAddrPostalCode}
                                                    onChange={config.onChange.sysAddrPostalCode}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    Country
                                                </Label>
                                                <Input
                                                    className="input-width-450"
                                                    value={config.options.sysAddrCountry}
                                                    onChange={config.onChange.sysAddrCountry}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    Latitude
                                                </Label>
                                                <Input
                                                    className="input-width-450"
                                                    value={config.options.sysLocLat}
                                                    onChange={config.onChange.sysLocLat}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    Longitude
                                                </Label>
                                                <Input
                                                    className="input-width-450"
                                                    value={config.options.sysLocLong}
                                                    onChange={config.onChange.sysLocLong}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    System Memo
                                                </Label>
                                                <Input
                                                    className="input-width-450"
                                                    value={config.options.sysMemo}
                                                    onChange={config.onChange.sysMemo}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Segment>
                                </Segment.Group>
                          </React.Fragment>
                      );
                  }}
              </ConfigOptionsAPI>
        );
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/system/probeConfig.tsx